import io from 'socket.io-client'
import * as exception from '@/utils/exception'
import { tenantId } from '@/utils/tenantUrl'
import { useCartStore } from '@/stores/common/cartStore'
import { useBulletScreenStore } from '@/stores/customer/bulletScreenStore'

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect(param) {

    // 如果已经连接状态的socket存在，返回
    if (this.socket && this.socket.connected) {
      return
    }

    // 断开旧连接（如果有）
    if (this.socket) {
      this.socket.disconnect();
    }

    this.socket = io(process.env.VUE_APP_SOCKET_URL, {
      query: { roomId : tenantId + param },
      transports: ['websocket']
    });

    this.socket.on('connect_error', (err) => {
      console.error('Socket.IO connection error:', err.message);
      throw new exception.SystemException
    });

    // online人数监听
    this.socket.on('online-count', (param) =>{
      useCartStore().setOnlineCount(param)
    })

    // 购物车更新
    this.socket.on('cart-change', (param) =>{
      useCartStore().updateCart(param)
    })

    // 购物项目更新
    this.socket.on('bullet-screen-add', (param) =>{
      useBulletScreenStore().addBulletScreen(param)
    })
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data)
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const socketService = new SocketService();
export default socketService;